{
    "Accessibility Menu": "قائمة إمكانية الوصول",
    "Reset settings": "إعادة تعيين الإعدادات",
    "Close": "إغلاق",
    "Content Adjustments": "تعديلات المحتوى",
    "Adjust Font Size": "تعديل حجم الخط",
    "Highlight Title": "تسليط الضوء على العنوان",
    "Highlight Links": "تسليط الضوء على الروابط",
    "Readable Font": "خط سهل القراءة",
    "Color Adjustments": "تعديلات الألوان",
    "Dark Contrast": "تباين داكن",
    "Light Contrast": "تباين فاتح",
    "High Contrast": "تباين عالي",
    "High Saturation": "تشبع عالي",
    "Low Saturation": "تشبع منخفض",
    "Monochrome": "أحادي اللون",
    "Tools": "أدوات",
    "Reading Guide": "دليل القراءة",
    "Stop Animations": "إيقاف الرسوم المتحركة",
    "Big Cursor": "مؤشر كبير",
    "Increase Font Size": "زيادة حجم الخط",
    "Decrease Font Size": "تقليل حجم الخط",
    "Letter Spacing": "تباعد الحروف",
    "Line Height": "ارتفاع السطر",
    "Font Weight": "سماكة الخط",
    "Dyslexia Font": "خط القراءة لمن يعانون من عسر القراءة",
    "Language": "اللغة",
    "Open Accessibility Menu": "افتح قائمة الوصول"
}
